import { rem, transparentize } from "polished";
import styled from "styled-components";

export const Input = styled.input`
  border: 1px solid ${({ theme }) => theme.colors.sectionBorder};
  border-radius: ${rem(4)};
  outline-color: ${({ theme }) => theme.colors.vividBlue};

  &::placeholder {
    color: ${({ theme }) => transparentize(0.5, theme.colors.lightSecondary)};
  }

  &:hover {
    border-color: ${({ theme }) => theme.colors.hoverBorder};
  }

  ${({ theme }) => theme.typography.bodyText.b4reg}
`;
